module.exports = __webpack_public_path__ + "static/media/iconSaveDate.56c08cd9.svg";